import Avatar from 'app/seedly-component-library/avatar-new';
import React, { useContext } from 'react';
import { useSelectGroupById } from 'entity/group/groupHooks';
import { useRouter } from 'next/router';

import mixpanel, { trackedEvents } from 'utils/mixpanel';
import clsx from 'clsx';
import MenuTag from './MenuTag';
import useFeedList from '../hooks/useFeedList';
import { CommunityPageContext } from '../context/CommunityPageContext';

const MobileBarMenu = () => {
  const { pageType, setPageType, groupId } = useContext(CommunityPageContext);
  const group = useSelectGroupById(groupId);
  const router = useRouter();
  const feedList = useFeedList();
  const tagList = feedList.map(feed => {
    const isActive = pageType === feed.value;
    return (
      <MenuTag
        isActive={isActive}
        key={feed.name}
        onClick={() => {
          if (feed.trackingParam) {
            mixpanel.track(trackedEvents.CommunityTopBarClicked, {
              param: feed.trackingParam,
            });
          }
          setPageType(feed.value);
          router.push('/community', '/community', { shallow: true });
        }}
      >
        <p
          className={clsx(
            'whitespace-nowrap',
            isActive ? 'text-white' : 'text-neutral-700',
          )}
        >
          {feed.icon}&nbsp;{feed.name}
        </p>
      </MenuTag>
    );
  });

  return (
    <div className="my-1 p-4 bg-white">
      <div className="flex flex-row w-full gap-2 whitespace-nowrap overflow-scroll	">
        {group && pageType === 'group' && (
          <>
            <MenuTag isActive>
              <div className="flex gap-1 items-center">
                <Avatar sizeClass="avatar-2" src={group.profileImage} />
                <p className="whitespace-nowrap text-white">{group.name}</p>
              </div>
            </MenuTag>
            <div className="vertical-divider h-[26px]" />
          </>
        )}
        <div className="flex gap-1 items-center">{tagList}</div>
        <div className="vertical-divider h-[26px]" />
        <MenuTag
          isActive={pageType === 'discover-groups'}
          onClick={() => {
            setPageType('discover-groups');
            mixpanel.track(trackedEvents.CommunityTopBarClicked, {
              param: 'groups',
            });
          }}
        >
          <p
            className={clsx(
              'whitespace-nowrap',
              pageType === 'discover-groups'
                ? 'text-white'
                : 'text-neutral-700',
            )}
          >
            <span role="img" aria-label="group">
              👥
            </span>
            &nbsp; Groups
          </p>
        </MenuTag>
      </div>
    </div>
  );
};

export default MobileBarMenu;
